module.exports = __webpack_public_path__ + "static/media/handshake-court.55ea0b61.jpg";